import service from "../services/colors.service"; // Asegúrate de que el servicio esté configurado correctamente

export const colors = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        async getColors() {
            try {
                const response = await service.getColors();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save(context, data) {
            try {
                let response;
                if (data.id === 0) {
                    response = await service.createData(data);
                } else {
                    response = await service.updateData(data.id, data);
                }
                return response;
            } catch (error) {
                console.error("Error save projects:", error);
                return error.response;
            }
        },
        async delete(context, id) {
            try {
                const response = await service.deleteData(id);
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response;; // Propaga el error para que sea manejado en el componente
            }
        },
    },
    mutations: {
    },
};
